import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { GQLShopFieldsContentsBenefitSectionLayout } from '../generated/graphql'
import { Table } from './table'

const Outer = styled.div`
  margin-top: 2rem;
`

const HeadRow = styled.div`
  background-color: #EEEEEE;
  display: flex;
  @media (max-width: 40rem){
    margin-left: calc(var(--side-margin) * -1);
    margin-right: calc(var(--side-margin) * -1);
    flex-direction: column; 
  }
`

const Label = styled.div`
  background-color: var(--blue);
  color: white;
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
  padding-left: 2.3125rem;
  padding-right: 2.3125rem;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  @media (max-width: 40rem){
    font-size: 1.125rem;
    line-height: 0.8333333333333334;
    letter-spacing: 0.02em;
  }
  &::after {
    content: '';
    display: block;
    position: absolute;
    left: 100%;
    top: 0;
    width: 1rem;
    height: 100%;
    background-color: var(--blue);
    clip-path: polygon(0 0, 0 100%, 100% 50%);
    @media (max-width: 40rem){
      clip-path: polygon(0 0, 50% 100%, 100% 0);
      top: 100%;
      left: 0;
      right: 0;
      margin-left: auto;
      margin-right: auto;
      height: 0.75rem;
      width: 2rem;
    }
  }
`

const Value = styled.div`
  font-size: 0.9375rem;
line-height: 1.5;
letter-spacing: 0.02em;
font-weight: 700;
white-space: pre-wrap;
padding-top: 1.125rem;
padding-bottom: 1.125rem;
padding-left: 2.5rem;
padding-right: 1.125rem;
color: var(--blue);
@media (max-width: 40rem){
  font-size: 0.875rem;
line-height: 1.6428571428571428;

padding-left: var(--page-margin);
  padding-right: var(--page-margin);
  padding-top: 1.5rem;
}
`

const TableContainer = styled.div`
  margin-top: 2.5625rem;
`

type ShopYutaiProps = {
  data: DeepPartial<GQLShopFieldsContentsBenefitSectionLayout>
}
export const ShopYutai: FunctionComponent<ShopYutaiProps> = ({data}) => {
  return <Outer>
    <HeadRow>
      <Label>
        優待
      </Label>
      <Value dangerouslySetInnerHTML={{__html: data.name ?? ''}}/>
    </HeadRow>
    <TableContainer>
      <Table data={data.details?.map(row => ({label: row?.label ?? '', value: row?.value ?? ''})) ?? []} />
    </TableContainer>
  </Outer>
}